import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
// import { Spinner } from "reactstrap";
import axios from "axios";

import AuthContext from "./context/auth-context";
import Navigation from "./components/navBar";
import authPage from "./components/auth";
import taskPage from "./components/task";
import history from "./history";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

class App extends React.Component {
  state = {
    isLoading: false, //state for making the App in loading and unloading state
    token: localStorage.getItem("token"), //token form local storage
    user: null, //User of the App
    msg: null, //GLobal message if any
    status: false,
  };

  //Load User using the token in the local storage on componentDidMount
  loadUser = async () => {
    this.setState({ isLoading: true });
    try {
      const res = await axios.get(
        " https://myhacktaskmanager.herokuapp.com/api/login/user",
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": `${this.state.token}`,
          },
        }
      );
      this.setState({ isLoading: false, user: res.data });
    } catch (err) {
      if (err.response) {
        console.log(err.response.data);
        localStorage.removeItem("token");
        this.setState({ isLoading: false, token: null });
      }
    }
  };

  componentDidMount() {
    this.loadUser();
  }

  //set state in login mode
  login = (token, user, msg) => {
    localStorage.setItem("token", token); //set token property in local storage as token
    this.setState({
      token: token,
      user: user,
      status: true,
      msg: msg,
    });
  };

  //Logout from the App by clearing state and local storage token
  logout = () => {
    localStorage.removeItem("token");
    this.setState({
      token: null,
      user: null,
      status: true,
      msg: "Logout Successful",
    });
  };

  //Create any global message
  createMessage = (status, msg) => {
    this.setState({
      status: status,
      msg: msg,
    });
  };

  render() {
    return (
      <BrowserRouter history={history}>
        <AuthContext.Provider
          value={{
            token: this.state.token,
            user: this.state.user,
            login: this.login,
            logout: this.logout,
            status: this.state.status,
            msg: this.state.msg,
            createMessage: this.createMessage,
          }}
        >
          <Navigation loading={this.state.loading} />
          <main className="main-content">
            <Switch>
              {!this.state.token && <Redirect from="/" to="/auth" exact />}
              {this.state.token && <Redirect from="/" to="/tasks" exact />}

              {this.state.token && <Redirect from="/auth" to="/tasks" exact />}
              {!this.state.token && <Redirect from="/tasks" to="/auth" exact />}

              {!this.state.token && (
                <Route path="/auth" exact component={authPage} />
              )}
              {this.state.token && (
                <Route path="/tasks" exact component={taskPage} />
              )}
            </Switch>
          </main>
          <footer
            style={{
              marginTop: "3rem",
              textAlign: "center",
              fontSize: "1.6rem",
              background: "#1c3d3d",
              color: "white",
            }}
          >
            Created by{" "}
            <a
              href="https://tekhin3.netlify.app"
              target="_blank"
              className="footerLink"
              rel="noopener noreferrer"
            >
              <i>tekhin</i>
            </a>
            , &#169; 2020
          </footer>
        </AuthContext.Provider>
      </BrowserRouter>
    );
  }
}

export default App;
